import React, { useRef, useEffect } from 'react';

const AudioVisualizer = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null); // To store reference of animation frame

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const bufferLength = 200; // Number of bars
    const dataArray = new Uint8Array(bufferLength);

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    let lastTime = 0; // Keeps track of the time for controlling animation speed

    const drawVisualizer = (time) => {
      // Make sure the frame is drawn at a slower rate
      if (time - lastTime < 100) { // Delay time (in milliseconds)
        animationRef.current = requestAnimationFrame(drawVisualizer);
        return;
      }

      // Update the lastTime
      lastTime = time;

      // Generate random values for each bar height (simulate frequency data)
      for (let i = 0; i < bufferLength; i++) {
        dataArray[i] = Math.random() * 150; // Random value between 0 and 255
      }

      ctx.clearRect(0, 0, canvasWidth, canvasHeight); // Clear the canvas

      let x = 0;
      const center = canvasHeight / 2;

      for (let i = 0; i < bufferLength; i++) {
        const barHeight = dataArray[i];
        const scaledBarHeight = (barHeight / 150) * (canvasHeight / 2);
        const barWidth = Math.random() * 4 + 2; // Random bar width between 2px and 6px

        ctx.fillStyle = 'rgb(29, 180, 105)'; // Bar color
        ctx.fillRect(x, center - scaledBarHeight, barWidth, scaledBarHeight); // Top half of the bar
        ctx.fillRect(x, center, barWidth, scaledBarHeight); // Bottom half of the bar

        x += barWidth + 4; // Adjust spacing between bars
      }

      // Request the next frame
      animationRef.current = requestAnimationFrame(drawVisualizer);
    };

    // Start drawing the visualizer
    animationRef.current = requestAnimationFrame(drawVisualizer);

    // Cleanup when component unmounts
    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, []); // Empty dependency array to run once on mount

  return (
    <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
      <span style={{ fontSize: '12px', color: 'rgba(136, 151, 174, 1)' }}>00:00</span>
      <canvas
        ref={canvasRef}
        width={200}
        height={50}
      ></canvas>
      <span style={{ fontSize: '12px', color: 'rgba(136, 151, 174, 1)' }}>00:00</span>
    </div>
  );
};

export default AudioVisualizer;


